import { Controller } from 'stimulus';

class ProductNavigationController extends Controller {
  connect() {
    this.isOpen = false;
  }

  onTogglerClick() {
    this.isOpen = !this.isOpen;

    this.toggleNavigation();
  }

  onLinkClick() {
    this.isOpen = false;

    this.toggleNavigation();
  }

  toggleNavigation() {
    this.listTarget.classList[this.isOpen ? 'add' : 'remove']('is-open');
  }
}

ProductNavigationController.targets = [
  'toggler',
  'list',
];

export default ProductNavigationController;
